import { connect } from "react-redux";
import Container from "./container";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(null, mapDispatchToProps)(Container);
